export default el => {
	const wrapper = document.querySelector(el);
	const input = wrapper.querySelector('.toggle-password__input');
	const elSwitch = wrapper.querySelector('.toggle-password__switch');
	if (elSwitch) {
		const switchText = elSwitch.innerText;
		const switchTextActive = elSwitch.getAttribute('data-toggle-text');

		let typeDefault = true;

		elSwitch.onclick = event => {
			if (typeDefault) {
				input.setAttribute('type', 'text');
				elSwitch.innerText = switchTextActive;
				typeDefault = false;
			} else {
				input.setAttribute('type', 'password');
				elSwitch.innerText = switchText;
				typeDefault = true;
			}
			elSwitch.setAttribute('aria-pressed', !typeDefault);

			input.focus();

			event.preventDefault();
		};
	}
};
